import store from '../container/store/store';
import menuDatas from '../components/content/MenuDatas'


export default function getCurrent(){
    var retour = null;
    var url = window.location.pathname;
    var match = url;
    Object.keys(menuDatas).forEach(menu => {
        var temp = url.replace(menuDatas[menu].path, "");
        if (temp.indexOf("/") === 0) {
            temp = temp.substring(1, temp.length);
        }
        if (temp.indexOf("/") === -1) {
            match = temp;
            if (match.length === 0) {
                match = null;
                return;
            }
        }
    });
    url = match;
    /*if (store.getState() != null && store.getState().menu != null && store.getState().menu.data != null) {
        retour = store.getState().menu.data;
    } else*/ // A voir si utile...
    if (url !== "" && retour === null && url !== null && url.indexOf("/") === -1) {
        retour = url;
    }
    return retour;
}


// WEBPACK FOOTER //
// ./src/services/Identity.js